export enum PropSharingRoleNames {}
